import React, { useRef, useState } from 'react';
import { ScrollerSpy, scrollBy } from '../../common/ScrollerSpy';
import { classIf } from '../../data/utils';
import Img from '../../common/Img';

export default function EventsScroller(props) {
    const scrollerRef = useRef(null);
    const [leftArrowEnabled, setLeftArrowEnabled] = useState(false);
    const [rightArrowEnabled, setRightArrowEnabled] = useState(false);

    return (
        <div className="c_37">
            <div className="c_37_1" data-direction="left" onClick={() => scrollBy(scrollerRef.current, -300)}>
                <Img className={"c_37_1_1" + classIf(leftArrowEnabled, 'active')} src="icon_arrow_expand_collapse_next.svg" height="24px" width="24px" />
            </div>
            <div className="c_37_2" ref={scrollerRef}>
                <ScrollerSpy toggle={setLeftArrowEnabled} />
                {props.children}
                <ScrollerSpy toggle={setRightArrowEnabled} />
            </div>
            <div className="c_37_1" data-direction="right" onClick={() => scrollBy(scrollerRef.current, 300)}>
                <Img className={"c_37_1_1" + classIf(rightArrowEnabled, 'active')} src="icon_arrow_expand_collapse_next.svg" height="24px" width="24px" data-rotate="180" />
            </div>
        </div>
    );
}
